import * as React from "react";
import { IdOrientation } from "../../../constants/IdOrientation";
import { Key } from "../key-handler/Key";
import { KeyEventType } from "../key-handler/KeyEventType";
import { KeyHandler } from "../key-handler/KeyHandler";
import { List } from "../list/List";
import { PageIndicators } from "./PageIndicators";
import { SlideshowArrow } from "./SlideshowArrow";
import { SlideshowPage } from "./SlideshowPage";
export var Slideshow = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, onPageChange = _a.onPageChange, page = _a.page, pages = _a.pages, _c = _a.showIndicators, showIndicators = _c === void 0 ? true : _c;
    var _d = React.useState(0), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = React.useState(undefined), hoverPage = _e[0], setHoverPage = _e[1];
    var previousPage = currentPage - 1;
    var nextPage = currentPage + 1;
    var isFirstPage = currentPage === 0;
    var isLastPage = currentPage === pages.length - 1;
    React.useEffect(function () {
        if (page !== undefined && page > 0 && page !== currentPage) {
            setCurrentPage(page);
        }
    }, [page]);
    var changePage = function (newPage) {
        if (currentPage === newPage || pages.length === newPage || newPage < 0) {
            return;
        }
        if (onPageChange) {
            onPageChange(newPage);
        }
        setCurrentPage(newPage);
    };
    var mouseOver = function (newPage) {
        if (hoverPage === newPage) {
            return;
        }
        setHoverPage(newPage);
    };
    var getRenderItem = function (item, index) {
        return (React.createElement(SlideshowPage, { currentPage: currentPage, hoverPage: hoverPage, item: item, index: index, key: index }));
    };
    var selectedClass = "slide-show-page-" + currentPage;
    return (React.createElement("div", { className: "slideshow__container " + className },
        React.createElement("div", { className: "slideshow" },
            React.createElement(List, { className: "flex " + selectedClass, items: pages, renderItem: getRenderItem }),
            showIndicators && (React.createElement(PageIndicators, { count: pages.length, onPageChange: changePage, currentPage: currentPage }))),
        React.createElement(SlideshowArrow, { className: "slideshow__arrow-left", hidden: isFirstPage, onClick: function () { return changePage(previousPage); }, onMouseOver: function () { return mouseOver(previousPage); }, onMouseOut: function () { return mouseOver(undefined); }, orientation: IdOrientation.Left }),
        React.createElement(SlideshowArrow, { className: "slideshow__arrow-right", hidden: isLastPage, onClick: function () { return changePage(nextPage); }, onMouseOver: function () { return mouseOver(nextPage); }, onMouseOut: function () { return mouseOver(undefined); }, orientation: IdOrientation.Right }),
        React.createElement(KeyHandler, { keyCode: Key.LeftArrow, keyEventType: KeyEventType.Keyup, handler: function () { return changePage(previousPage); } }),
        React.createElement(KeyHandler, { keyCode: Key.RightArrow, keyEventType: KeyEventType.Keyup, handler: function () { return changePage(nextPage); } })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/slideshow/Slideshow.tsx
// module id = 2905
// module chunks = 3